import GlobaleInbox from "./GlobaleInbox";

const SentBox = () => {
  return <GlobaleInbox folder="Sent" />;
};

export default SentBox;
